export const AddressContent = {
  addressText:
    "SCO-69,clockton market,omaxe phase 1,backside of Apollo Pharmacy, New Chandigarh,140901",
  pickupTime: "up to 30 minutes",
};
